import { useEffect } from "react";
import CloseIcon from "../assets/crossIcon.svg";
const RpaEnhancementStages = ({ stages, setOpen, getTime }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  console.log("stagees", stages);
  return (
    <div className="fixed top-0 left-0 h-screen w-screen bg-[#017C5780] flex justify-center items-center z-[1201] ">
      <div className="relative w-[60%] h-[50%] bg-white rounded-[20px] p-10">
        {" "}
        <div
          className="absolute top-4 right-5 cursor-pointer"
          onClick={() => setOpen(null)}
        >
          <img src={CloseIcon} alt="close-icon" />
        </div>
        <div className="text-xl font-semibold">Enhancement Stages Report</div>
        <div
          style={{
            border: "1px solid #E5E5E5",
            padding: "32px",
            marginTop: "12px",
            height: "90%",
            borderRadius: "16px",
          }}
        >
          <div className="font-semibold grid grid-cols-2 gap-4 ">
            <div>Enhancement</div>
            <div>Process Time</div>
          </div>
          <div style={{ border: "1px solid #d5d5d5", marginBlock: "8px" }} />

          <div className="h-[90%] mt-3 overflow-y-auto">
            {stages?.stages?.map((stage, idx) => {
              return (
                <div
                  key={idx}
                  className={`${
                    idx % 2 === 0 ? "bg-[#f5f5f5]" : "bg-white"
                  } grid grid-cols-2 gap-3 p-2 mb-1`}
                >
                  <div>Enhancement {idx + 1}</div>
                  <div>
                    <div
                      style={{
                        color: stages?.colorData?.textColor,
                        backgroundColor: stages?.colorData?.bgColor,
                        width: "fit-content",
                        padding: "4px",
                      }}
                    >
                      {getTime(Number(stage.processTime) * 60)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RpaEnhancementStages;
